import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "margin" }, null, -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "margin" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_BaseHeader = _resolveComponent("BaseHeader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.IsLoggedIn)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseHeader),
        _createVNode(_component_router_view)
      ]),
      _hoisted_4
    ])
  ], 64))
}